import { StageDefinition } from './StageDefinition';

export const stage06: StageDefinition = {
    platforms: [
        [359.99999999999966, 1],
        [32.72727272727273, 2],
        [180.00000000000006, 2],
        [188.18181818181824, 2],
        [229.09090909090918, 2],
        [237.27272727272737, 2],
        [270.0000000000001, 2],
        [278.1818181818183, 2],
        [56.842105263157904, 4],
    ],
    traps: [
        [162.58064516129033, 0],
        [209.03225806451618, 0],
        [255.48387096774204, 0],
        [88.42105263157895, 4],
        [101.05263157894736, 4],
        [113.68421052631577, 4],
    ],
    stars: [
        [100, 0],
        [184, 5],
        [233, 5],
        [273, 5],
        [104, 8],
    ],
};
